import { render, staticRenderFns } from "./objectiveQues.vue?vue&type=template&id=2a84d3e2&"
import script from "./objectiveQues.vue?vue&type=script&lang=js&"
export * from "./objectiveQues.vue?vue&type=script&lang=js&"
import style0 from "./objectiveQues.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports